import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from "react-router";
import {
    Table,
    Form,
    Accordion,
    Button,
    FloatingLabel,
    Alert,
} from "react-bootstrap";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";

const AddSitePage = () => {
    const navigate = useNavigate();
    let { setAlert } = useContext(ContextComponent);
    let [canRender, setCanRnder] = useState(false);

    let [siteName, setSiteName] = useState("");
    let [description, setDescription] = useState("");
    let [siteBGColor, SetSiteBGColor] = useState("");
    let [siteStartButtonColor, SetSiteStartButtonColor] = useState("");
    let [siteStartButtonTextColor, SetSiteStartButtonTextColor] = useState("");
    let [classicview, setClassicview] = useState(false);
    let [image0Text, setImage0Text] = useState("");
    let [image40Text, setImage40Text] = useState("");
    let [image70Text, setImage70Text] = useState("");

    let [imgDataArray, setImgDataArray] = useState(["", "", ""]);

    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetIndex = parseInt(
            e.currentTarget.attributes["imgindex"].value,
            10,
        );
        document
            .querySelector(".indi-add-img-wrapper-" + targetIndex)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetIndex,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgDataArray[targetIndex] = dataUri;
            imgPreviewEle.src = dataUri;
            setImgDataArray(imgDataArray);
        });
    };

    let [showAlert, setShowAlert] = useState(false);
    let [formValidateErrorMessage, setFormValidateErrorMessage] = useState("");

    const siteNameHandler = (e) => {
        setSiteName(e.currentTarget.value);
    };

    const siteDescriptionHandler = (e) => {
        setDescription(e.currentTarget.value);
    };

    const siteBGColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteBGColor(val);
        let logoEle1 = document.getElementById("siteBG-Color1");
        logoEle1.value = val;
    };

    const siteBGInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteBGColor(val);
        let logoEle = document.getElementById("siteBG-Color");
        logoEle.value = val;
    };

    const siteStartButtonColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteStartButtonColor(val);
        let logoEle1 = document.getElementById("startButtonColor1");
        logoEle1.value = val;
    };

    const siteStartButtonInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteStartButtonColor(val);
        let logoEle = document.getElementById("startButtonColor");
        logoEle.value = val;
    };

    const siteStartButtonTextColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteStartButtonTextColor(val);
        let logoEle1 = document.getElementById("startButtonTextColor1");
        logoEle1.value = val;
    };

    const siteStartButtonTextInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        SetSiteStartButtonTextColor(val);
        let logoEle = document.getElementById("startButtonTextColor");
        logoEle.value = val;
    };

    const siteClassicviewHandler = (e) => {
        setClassicview(e.currentTarget.checked);
    };

    const Image0textHandler = (e) => {
        setImage0Text(e.currentTarget.value);
    };

    const Image40textHandler = (e) => {
        setImage40Text(e.currentTarget.value);
    };

    const Image70textHandler = (e) => {
        setImage70Text(e.currentTarget.value);
    };

    const onSaveSite = (e) => {
        let siteInfo = {
            name: siteName,
            description,
            siteBGColor,
            siteStartButtonColor,
            siteStartButtonTextColor,
            classicview,

            // ** ----image0 needs to add------- ** //
            image0: imgDataArray[0],
            image0text: image0Text,
            // ** ----image40 needs to add------- ** //
            image40: imgDataArray[1],
            image40text: image40Text,
            // ** ----image70 needs to add------- ** //
            image70: imgDataArray[2],
            image70text: image70Text,
        };

        if (validateForm(siteInfo)) {
            submitSiteForm(siteInfo);
        }
        return false;
    };

    const validateForm = (formData) => {
        let errMsg = [];
        if (formData.name.trim().length === 0) {
            errMsg.push("Site name is required");
        }
        // if (formData.backgroundImage.trim().length === 0) {
        //     errMsg.push("Template background image is required");
        // }
        // if (formData.logoImage.trim().length === 0) {
        //     errMsg.push("Template logo image is required");
        // }
        if (errMsg.length) {
            setShowAlert(true);
            setFormValidateErrorMessage(errMsg.join(", "));
            return false;
        } else {
            setShowAlert(false);
            setFormValidateErrorMessage("");
            return true;
        }
    };

    const submitSiteForm = (info) => {
        const success = (res) => {
            navigate(Utils.APP_URLS.TEMPLATES_PAGE);
            setAlert({
                show: true,
                message: "Template added successfully",
            });
        };
        const fail = (err) => {
            console.log(err);
        };

        console.log("final form:::", info)

        // try {
        //     Utils.addNewTemplate(info).then(success, fail);
        // } catch (e) {
        //     console.log(e);
        // }
    };

    const navigateToSitesPage = (e) => {
        navigate(Utils.APP_URLS.SITES_PAGE);
    };

    useEffect(() => {
        setCanRnder(true);
    }, []);


    return (
        <>
            {canRender && (
                <form className="indi-add-template-form">
                    <div>
                        <div className="indi-body-title">Add New Site</div>
                        {showAlert && (
                            <Alert className="indi-status-message in" variant="danger">
                                {formValidateErrorMessage}
                            </Alert>
                        )}
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Site name">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="name"
                                    placeholder="Enter template name"
                                    autoComplete="off"
                                    onChange={siteNameHandler}
                                />
                            </FloatingLabel>
                            <div className="indi-right-button-wrapper">
                                <Button onClick={onSaveSite}>Save</Button>
                                <Button onClick={navigateToSitesPage}>Cancel</Button>
                            </div>
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Description">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="description"
                                    placeholder="Enter Site Description"
                                    autoComplete="off"
                                    onChange={siteDescriptionHandler}
                                />
                            </FloatingLabel>
                        </div>

                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Site BG Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="siteBG-Color"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteBGColorHandler}
                                    defaultValue={siteBGColor}
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="siteBG-Color1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteBGInputColorHandler}
                                defaultValue={siteBGColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Start Button Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="startButtonColor"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteStartButtonColorHandler}
                                    defaultValue={siteStartButtonColor}
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="startButtonColor1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteStartButtonInputColorHandler}
                                defaultValue={siteStartButtonColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Start Button Text Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="startButtonTextColor"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteStartButtonTextColorHandler}
                                    defaultValue={siteStartButtonTextColor}
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="startButtonTextColor1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteStartButtonTextInputColorHandler}
                                defaultValue={siteStartButtonTextColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <Form.Check
                                type="switch"
                                className="indi-input-switch-field"
                                id="classicview"
                                defaultChecked={classicview}
                                label="Enable Classic View?"
                                onChange={siteClassicviewHandler}
                            />
                        </div>
                        <Accordion className="indi-data-table-wrapper" defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Image uploads</Accordion.Header>
                                <Accordion.Body>
                                    <Table responsive="sm">
                                        <thead className="indi-data-table-header">
                                            <tr>
                                                {/* <th>Image place</th> */}
                                                <th className="text-center">Image Text</th>
                                                <th className="text-center">Upload</th>
                                                <th className="text-center">Preview</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-site-image0-name">
                                                    Image0
                                                </td> */}
                                                <td className="indi-data-table-td-image0-name text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image0 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image0text"
                                                                placeholder="Enter Image0 text"
                                                                autoComplete="off"
                                                                onChange={Image0textHandler}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            id="iconImage"
                                                            imgindex={0}
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-img-prevew text-center">
                                                    <div className="indi-add-img-wrapper-0">no preview</div>
                                                    <img
                                                        src=""
                                                        alt="background"
                                                        className="d-none indi-add-img-wrapper-preview indi-add-img-wrapper-preview-0"
                                                    />
                                                </td>
                                            </tr>

                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-site-image40-name">
                                                    Image40
                                                </td> */}
                                                <td className="indi-data-table-td-image40-name text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image40 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image40text"
                                                                placeholder="Enter Image40 text"
                                                                autoComplete="off"
                                                                onChange={Image40textHandler}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={1}
                                                            id="iconImage"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-img-prevew text-center">
                                                    <div className="indi-add-img-wrapper-1">no preview</div>
                                                    <img
                                                        src=""
                                                        alt="background"
                                                        className="d-none indi-add-img-wrapper-preview indi-add-img-wrapper-preview-1"
                                                    />
                                                </td>
                                            </tr>

                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-image70-name">
                                                    Image70
                                                </td> */}
                                                <td className="indi-data-table-td-user-email text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image70 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image70text"
                                                                placeholder="Enter Image70 text"
                                                                autoComplete="off"
                                                                onChange={Image70textHandler}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={2}
                                                            id="iconImage"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-img-prevew text-center">
                                                    <div className="indi-add-img-wrapper-2">no preview</div>
                                                    <img
                                                        src=""
                                                        alt="background"
                                                        className="d-none indi-add-img-wrapper-preview indi-add-img-wrapper-preview-2"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </form>
            )}
        </>
    );
};

export default AddSitePage;